import {brandConfigObjectMap,} from "./brandConfig";

export const brandConfigMap = new Map();

export function getBrandConfig(productId) {
    const brandConfigObject = brandConfigObjectMap.get(productId);
    return {
        productId,
        gameTitle: brandConfigObject.gameTitle,
        gameTag: brandConfigObject.gameTag,
        gameUrl: brandConfigObject.gameUrl,
        termsConditionsUrl: brandConfigObject.termsConditionsUrl,
        serviceId: brandConfigObject.serviceId,
        brand: brandConfigObject.brand,
        languageId: brandConfigObject.languageId,
        footerTextColor: brandConfigObject.footerTextColor,
        walletIcon: brandConfigObject.walletIcon,
        redeemButton: brandConfigObject.redeemButton,
        selectVoucherBackground: brandConfigObject.selectVoucherBackground,
        newSelectVoucherLayout: brandConfigObject.newSelectVoucherLayout,
        rewardPopUp: brandConfigObject.rewardPopUp,
        rewardPopUpImage: brandConfigObject.rewardPopUpImage,
        styleOptions: (() => {
            const source = brandConfigObject?.styleOptions ?? brandConfigObject;
            const textColor = source?.textColor ?? brandConfigObject?.footerTextColor ?? undefined;
            const accentColor = source?.accentColor ?? undefined;
            const secondaryAccentColor = source?.secondaryAccentColor ?? undefined;
            const backgroundColor = source?.backgroundColor ?? undefined;
            const styleOptions = { textColor, accentColor, secondaryAccentColor, backgroundColor };
            return styleOptions;
        })()
    }
}
